import LabeledData from 'components/common/LabeledData';

import { GiFountainPen } from 'react-icons/gi';

const BookAuthorsList = ({ authors, ...rest }) => {
    const title = `Author${authors?.length > 1 ? 's' : ''}`;

    return (
        <div {...rest}>
            {
                authors?.length > 0 && (
                    <LabeledData label={title}>
                        <ul className="reset">
                            {
                                authors.map(({ name }, idx) => (
                                    <li key={idx} className="flex">
                                        <GiFountainPen className="mr-1 mt-1" />
                                        { name }
                                    </li>
                                ))
                            }
                        </ul>
                    </LabeledData>
                )
            }
        </div>
    )
}

export default BookAuthorsList